import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import Topbar from '../../components/Topbar/Topbar';
import { SidebarProvider, useSidebar } from '../Sidebar/SidebarContext';
import { isAuthenticated } from '../../utils/auth';
import '../Sidebar/Sidebar.css';

function AdminShell() {
  const { collapsed, mobileOpen, closeMobile } = useSidebar();
  const location = useLocation();

  useEffect(() => {
    closeMobile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <div className={`admin-shell ${collapsed ? 'sidebar-collapsed' : ''} ${mobileOpen ? 'sidebar-mobile-open' : ''}`}>
      {mobileOpen && (
        <button
          type="button"
          className="sidebar-backdrop"
          aria-label="Close menu"
          onClick={closeMobile}
        />
      )}
      <Sidebar />
      <div className="admin-main">
        <Topbar />
        <div className="admin-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default function AdminLayout() {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  return (
    <SidebarProvider>
      <AdminShell />
    </SidebarProvider>
  );
}
